import { put, call, select } from 'redux-saga/effects'
import { transformData } from './helpers'
import { EmployeeInfoFormType } from 'pages/Profile/EmployeeInfo/types'
import * as Actions from './actions'
import * as M from 'domain/env'
import Api from 'domain/api'
import I from 'immutable'
import { pageIsLoading } from 'domain/loading'

export function* ensureEmployeeInfo() {
  const headers = yield select(M.userToken)
  if (!headers) return
  try {
    const {
      data: { data }
    } = yield call(Api.getEmployeeInfo, {
      headers: { Authorization: `Bearer ${headers}` }
    })
    yield put({ type: Actions.employeeInfo.success, payload: I.fromJS(data) })
  } catch (err) {
    yield put({
      type: Actions.employeeInfo.failure,
      err
    })
  }
}

export function* ensureAddEmployeeInfo({
  payload
}: {
  payload: EmployeeInfoFormType
  type: string
}) {
  const headers = yield select(M.userToken)
  if (!headers) return
  try {
    yield put({ type: pageIsLoading, payload: true })
    const {
      data: { data }
    } = yield call(Api.postEmployeeInfo, {
      headers: { Authorization: `Bearer ${headers}` },
      data: transformData(payload)
    })
    yield put({ type: Actions.addEmployeeInfo.SUCCESS, payload: I.fromJS(data) })
    yield put({ type: Actions.employeeInfo.type })
  } catch (err) {
    yield put({
      type: Actions.addEmployeeInfo.FAILURE,
      err
    })
  } finally {
    yield put({ type: pageIsLoading, payload: false })
  }
}
